import { useEffect } from 'react';
import { snackbarType } from 'constants/snackbarType';
import { useSelector } from 'react-redux';
import { useToast } from './useToast';
import { clearSnackbar } from 'actions/actionCreators/snackbarActions';
import { useDispatch } from 'react-redux';

const ToastNotifier = () => {
  const dispatch = useDispatch();
  const addToast = useToast();

  const snackbar = useSelector(state => state.snackbar);
  useEffect(() => {
    if (!snackbar.msg && !snackbar.type) return;
    switch (snackbar.type) {
      case snackbarType.error: {
        addToast(snackbar.msg, 'error', snackbar.correlationId);
        dispatch(clearSnackbar());
        break;
      }
      case snackbarType.info: {
        const { msg, autoDismiss, refreshPage, shouldAddNotification } = snackbar;
        addToast(msg, 'info', snackbar.correlationId, autoDismiss, refreshPage, shouldAddNotification);
        dispatch(clearSnackbar());
        break;
      }
      case snackbarType.warning: {
        addToast(snackbar.msg, 'warning', snackbar.correlationId);
        dispatch(clearSnackbar());
        break;
      }
      default:
        break;
    }
  }, [snackbar, dispatch, addToast]);

  return null;
};

export default ToastNotifier;
